import { jsx as l } from "react/jsx-runtime";
import c from "@mui/material/SvgIcon";
import * as t from "react";
import { forwardRef as m } from "react";
const f = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "6 8 20 16", ...e }, /* @__PURE__ */ t.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M6 11.95V9.94C6.034 8.858 6.863 8 7.875 8h6.938c.71 0 1.35 1.446 1.35 1.446L13.2 11.709a1.2 1.2 0 0 1-.725.24zm7.125 1.339H6v8.703C6 23.1 6.84 24 7.875 24h16.25C25.16 24 26 23.1 26 21.992v-9.373c0-1.109-.84-2.008-1.875-2.008H17.25l-3.437 2.45a1.2 1.2 0 0 1-.688.228", clipRule: "evenodd" })), a = /* @__PURE__ */ m(({ size: e = "inherit", sx: o, ...i }, n) => {
  const r = typeof o == "function" ? o : {
    fontSize: e,
    ...o
  };
  return /* @__PURE__ */ l(c, {
    ...i,
    ref: n,
    component: f,
    inheritViewBox: !0,
    sx: r
  });
});
a.displayName = "svg_file";
export {
  a as default
};
